import m from 'mithril';
import vwPaymentSession from './views/vwPaymentSession';
import vwConfirmation from './views/vwConfirmation';
import vwClosed from './views/vwClosed';

const routes = {
	'/': {
		render: (attrs) => {
			return m(vwPaymentSession, attrs.attrs);
		},
	},
	'/confirmation': {
		render: (attrs) => {
			return m(vwConfirmation, attrs.attrs);
		},
	},
	'/closed': {
		render: () => {
			return m(vwClosed);
		},
	},
};

export default routes;
